import { usePagination } from 'react-instantsearch'

export default function AlgoliaIndexPagination(props) {
  const {
    currentRefinement,
    nbHits,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
  } = usePagination(props)

  const previousPageIndex = currentRefinement - 1
  const nextPageIndex = currentRefinement + 1
  const itemClass = 'text-md text-blue-oxford hover:text-gold'

  if (nbHits === 0 || nbPages <= 1) {
    return null
  }

  return (
    <div className="wrapper--outside border-t border-grey-light">
      <div className="wrapper wrapper--max flex justify-between gap-x-sm py-xl ">
        <span className={itemClass}>
          Page {currentRefinement + 1} of {nbPages}
        </span>

        <ul className="flex">
          {!isFirstPage ? (
            <li>
              <button
                onClick={() => {
                  refine(previousPageIndex)
                  if (typeof window !== 'undefined') {
                    window.scrollTo({
                      top: 0,
                      left: 0,
                      behavior: 'smooth',
                    })
                  }
                }}
                className={itemClass}>
                Previous
              </button>
            </li>
          ) : null}

          {!isFirstPage && !isLastPage ? (
            <li className={` ${itemClass} px-3xs`}> / </li>
          ) : null}

          {!isLastPage ? (
            <li>
              <button
                onClick={() => {
                  refine(nextPageIndex)
                  if (typeof window !== 'undefined') {
                    window.scrollTo({
                      top: 0,
                      left: 0,
                      behavior: 'smooth',
                    })
                  }
                }}
                className={itemClass}>
                Next
              </button>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  )
}
